export default __webpack_public_path__ + "files/media/s.18d6d58e.jpg";